<!--
 * @Description: 修改密码和操作密码
 * @Version: 2.0
 * @Autor: Lianzhidong
 * @Date: 2022-03-12 20:13:36
 * @LastEditors: Lianzhidong
 * @LastEditTime: 2022-03-12 21:04:39
-->
<template>
  <div class="password">
    <el-descriptions direction="vertical" :column="2" border>
      <el-descriptions-item label="旧登录密码">
        <el-input
          v-model="param.passWord"
          type="password"
          show-password
        ></el-input>
      </el-descriptions-item>
      <el-descriptions-item label="新登录密码"
        ><el-input
          v-model="param.newPassWord"
          type="password"
          show-password
        ></el-input
      ></el-descriptions-item>
      <el-descriptions-item label="旧操作密码"
        ><el-input
          v-model="param.doublePassWord"
          type="password"
          show-password
        ></el-input
      ></el-descriptions-item>
      <el-descriptions-item label="新操作密码"
        ><el-input
          v-model="param.newDoublePassWord"
          type="password"
          show-password
        ></el-input
      ></el-descriptions-item>
    </el-descriptions>
    <div class="password-btn">
      <el-button type="primary" @click="onSubmit" :loading="isLoading">
        确认修改</el-button
      >
    </div>
  </div>
</template>

<script>
import HTTP_USER from "@/api/user";
export default {
  name: "Password",
  data() {
    return {
      param: {
        passWord: "",
        newPassWord: "",
        newDoublePassWord: "",
        doublePassWord: "",
      },
      isLoading: false,
    };
  },
  methods: {
    onSubmit() {
      if (this.param.passWord.length === 0) {
        this.$message.warning("请输入旧登录密码");
        return;
      }
      if (this.param.newPassWord.length === 0) {
        this.$message.warning("请输入新登录密码");
        return;
      }
      if (this.param.doublePassWord.length === 0) {
        this.$message.warning("请输入旧操作密码");
        return;
      }
      if (this.param.newDoublePassWord.length === 0) {
        this.$message.warning("请输入新操作密码");
        return;
      }
      this.handleSubmit();
    },
    async handleSubmit() {
      this.isLoading = true;
      try {
        const res = await HTTP_USER.updatePassword(this.param);
        this.isLoading = false;
        if (res.code === 200) {
          this.$message.success("修改成功");
          this.param = {
            passWord: "",
            newPassWord: "",
            newDoublePassWord: "",
            doublePassWord: "",
          };
        } else {
          this.$message.error(
            typeof res.msg === "string" ? res.msg : "请求出错，请联系管理员"
          );
        }
      } catch (e) {
        console.error(e);
        this.isLoading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.password {
  padding: 5px;
  &-btn {
    margin-top: 20px;
    display: flex;
    justify-content: center;
  }
}
</style>
